/* eslint-disable react/jsx-props-no-spreading */
import React, { SVGProps } from 'react';

const MobileIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={12}
    height={18}
    viewBox="0 0 12 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
    data-palette="MobileIcon">
    <path
      d="M2.11 0C1.271 0 .595.563.595 1.26v15.81c0 .697.676 1.26 1.513 1.26h7.974c.837 0 1.513-.563 1.513-1.26V1.26c0-.697-.676-1.26-1.513-1.26H2.11Zm7.203.478c.075 0 .147.027.2.076a.248.248 0 0 1 .083.183c0 .068-.03.134-.083.182a.297.297 0 0 1-.2.076.297.297 0 0 1-.2-.076.248.248 0 0 1-.083-.182c0-.069.03-.135.083-.183a.297.297 0 0 1 .2-.076ZM5.142.614H7.05c.045 0 .084.037.084.084 0 .046-.04.084-.084.084H5.14a.085.085 0 0 1-.084-.084c0-.047.04-.084.085-.084Zm-3.026.09c.052 0 .092.037.092.084 0 .047-.04.09-.092.09a.092.092 0 0 1-.092-.09c0-.047.04-.084.092-.084Zm.325.007c.05 0 .092.033.092.077 0 .045-.043.084-.092.084a.084.084 0 0 1-.084-.084c0-.044.036-.077.084-.077Zm-1.343.846h9.996v14.835H1.098V1.557Zm3.79 15.475h2.417c.167 0 .304.097.304.22v.252c0 .122-.137.219-.304.219H4.887c-.167 0-.304-.097-.304-.22v-.252c0-.122.137-.22.304-.22Z"
      fill="var(--primaryText)"
    />
  </svg>
);

export default MobileIcon;
